export default __webpack_public_path__ + "static/nammba-white-5561c52991590dd076c5efc23889b6fc.svg";